/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type PhoneNumber = {
  number?: string | undefined;
  countryCode?: string | undefined;
};

/** @internal */
export const PhoneNumber$inboundSchema: z.ZodType<
  PhoneNumber,
  z.ZodTypeDef,
  unknown
> = z.object({
  number: z.string().optional(),
  countryCode: z.string().optional(),
});
/** @internal */
export type PhoneNumber$Outbound = {
  number?: string | undefined;
  countryCode?: string | undefined;
};

/** @internal */
export const PhoneNumber$outboundSchema: z.ZodType<
  PhoneNumber$Outbound,
  z.ZodTypeDef,
  PhoneNumber
> = z.object({
  number: z.string().optional(),
  countryCode: z.string().optional(),
});

export function phoneNumberToJSON(phoneNumber: PhoneNumber): string {
  return JSON.stringify(PhoneNumber$outboundSchema.parse(phoneNumber));
}
export function phoneNumberFromJSON(
  jsonString: string,
): SafeParseResult<PhoneNumber, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PhoneNumber$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PhoneNumber' from JSON`,
  );
}
